import { List } from 'immutable'
import { WrappedComponentProps } from 'react-intl'

export enum OPERATORS {
  AND = 'and',
  OR = 'or',
}

export enum CRITERIA {
  IN = 'in',
  NOT_IN = 'not_in',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  EQ = 'eq',
  NEQ = 'neq',
}

export interface Option {
  value: string | number
  label:
    | string
    | {
        title: string
      }
}

export interface FilteredInput {
  value: number
  label: string
  multiple?: boolean
  options?: Option[]
}

export interface Input {
  id: number
  title: string
  type?: string
  multiple?: boolean
  options?: Option[]
}

interface Condition {
  criteria: CRITERIA
  input: number | string | null
  input_title?: string
  input_type?: string
  values: (string | number)[] | Record<string, string>
}

export interface ConditionalValue {
  conditions: Condition[]
  input_groups?: (string | number)[] | Input[]
  inputs?: (string | number | Input | null)[]
  operator: OPERATORS
  uuid?: string
}

export interface PopulateValue {
  conditions: Condition[]
  inputs?: (string | number | Input | null)[]
  operator: OPERATORS
  population_values?: Record<string, string>
  trigger_input?: number | string | Input | null
  uuid?: string
}

export interface TaskInputsItem {
  task: string
  task_id: number
  inputs: Input[]
}

enum TREE_ITEM_TYPES {
  INPUT = 'input',
  INPUT_GROUP = 'input_group',
}

export interface TreeItem {
  id: number
  input_item_type: TREE_ITEM_TYPES
  options: Option[]
  inputs?: {
    id: number
    input_item_type: TREE_ITEM_TYPES.INPUT
    multiple?: boolean
    options: Record<string, string> | Option[]
    title: string
    type: string
  }[]
  title: string
  type: string
  multiple?: boolean
}

export type ConditionalLogicProps = WrappedComponentProps & {
  featureFlags: Record<string, boolean>
  input: {
    value: ConditionalValue[]
    onChange: (value: ConditionalValue[]) => void
  }
  formData: {
    id: number
    workflow: {
      id: number
    }
  }
  fetchTriggerInputs: (payload?: { id: number }) => void
  inputsList: List<TaskInputsItem>
  isFetching: boolean
  isFetchingInputs: boolean
  fetchTaskInputsTree: (payload?: { taskId: number }) => void
  taskInputs: List<TreeItem>
  isInputsTreeFetching: boolean
}

export type PopulateLogicProps = WrappedComponentProps & {
  featureFlags: Record<string, boolean>
  input: {
    value: PopulateValue[]
    onChange: (value: PopulateValue[]) => void
  }
  formData: {
    id: number
    workflow: {
      id: number
    }
  }
  fetchTriggerInputs: (payload?: { id: number }) => void
  inputsList: List<TaskInputsItem>
  isFetching: boolean
  fetchTaskInputsTree: (payload?: { taskId: number }) => void
  taskInputs: List<TreeItem>
  isInputsTreeFetching: boolean
}
